module.exports = __webpack_public_path__ + "static/img/rz(3).8565255d.jpeg";